import { cn } from '@/utils/cn';

export function ConnectionStatusBadge({
  status,
  score,
}: {
  status?: string;
  score?: number;
}) {
  const label = score != null ? `${score}%` : status ?? '—';
  const tone =
    (score != null && score >= 90) || status === 'HEALTHY'
      ? 'bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-200'
      : (score != null && score >= 70) || status === 'WARNING'
        ? 'bg-amber-100 text-amber-900 dark:bg-amber-950 dark:text-amber-200'
        : 'bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-200';

  return (
    <span className={cn('inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold', tone)}>
      {label}
    </span>
  );
}

export function TestStatusBadge({ status }: { status: string }) {
  const tone =
    status === 'PASSED'
      ? 'text-emerald-600 dark:text-emerald-400'
      : status === 'WARNING'
        ? 'text-amber-600 dark:text-amber-400'
        : 'text-red-600 dark:text-red-400';
  return <span className={cn('text-xs font-semibold uppercase', tone)}>{status}</span>;
}
